import { toast } from 'sonner';
import { useAnimationPreviewStore } from '@/features/smallapp/stores/animation-preview-store';
import { registerActionHandler } from '../action-registry';

/**
 * `previewAnimation` — opens the AnimationPreviewDialog with the currently-
 * selected animate.css class. Mirrors scio1's "Preview" button next to the
 * Animation select on the Live TV with Ads modal (liveTvAdsModal.html:262-264).
 *
 * Usage:
 *   { key: 'animation', type: 'select', options: [...],
 *     action: {
 *       label: 'Preview',
 *       handler: 'previewAnimation',
 *       displayOptions: { hideIf: { animation: ['random'] } }
 *     }
 *   }
 *
 * The handler reads `values[field.key]` (the current animation name) — works
 * whether the field key is `animation` (Live TV with Ads), `entryAnimation`
 * (some other smallapp), etc. No-op when the value is empty or 'random'.
 */
registerActionHandler('previewAnimation', async ({ values, field, t }) => {
  const animation = values[field.key];
  if (typeof animation !== 'string' || animation === '' || animation === 'random') {
    toast.error(t('Pick an animation first'));
    return;
  }
  useAnimationPreviewStore.getState().open(animation);
});
